import { useSelector } from 'react-redux';
import type { RootState } from '../../../store/store';
import { adminAccessPermissions, hasAnyPermission } from '../permissions';

export const useAdminCheck = () => {
  const user = useSelector((s: RootState) => s.auth.user);
  const isAuthenticated = useSelector((s: RootState) => s.auth.isAuthenticated);
  const isUserResolved = useSelector((s: RootState) => s.auth.isUserResolved);

  const hasAdminAccess = (user: RootState['auth']['user'] | null) => {
    if (!user) return false;
    const permissions = user.permissions || [];
    const roles = user.roles || [];
    return hasAnyPermission(permissions, adminAccessPermissions, roles);
  };

  const permissions = user?.permissions || [];
  const roles = user?.roles || [];

  return {
    isAdmin: hasAdminAccess(user),
    isAuthenticated,
    permissions,
    roles,
    isLoading: isAuthenticated && (!isUserResolved || !user),
  };
};
